import React from 'react';
import { isEmpty, keys, upperFirst, sortBy } from 'lodash'
import { withState, compose } from 'recompose';
import withFetchResources from 'hocs/bases/withFetchResources';
import withDynamicEditPage from 'hocs/extends/withDynamicEditPage'
import CmsApis from 'apis/cmsApis';
import PageContent from 'components/wrappers/PageContent';
import Paper from 'material-ui/Paper';
import MainHeader from 'components/headers/MainHeader';
import { updateObject } from 'helpers/objectHelpers';
import StateToolbar from 'components/bars/StateToolBar';
import Divider from 'material-ui/Divider';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import FormLinkPage from 'components/forms/FormLinkPage';
import { removeItemArrayByIndex, updateItemArrayByIndex } from 'helpers/arrayHelpers'
import CustomFlatButton from 'components/Button/CustomFlatButton'
import FontIcon from 'material-ui/FontIcon'
import withSnackBar from 'store/snackbar/withSnackBar'
import { Message } from 'semantic-ui-react'
import FormStaticPage from 'components/forms/FormStaticPage'

const styles = {
  wrapper: {
    display: 'flex',
    marginLeft: 30,
    marginBottom: 10,
  },
  label: {
    width: '10%',
    margin: '0px 30px 0 20px',
    fontWeight: 400,
  },
  addButton: {
    margin: 20,
    textAlign: 'center',
  },
};

const PageLocations = compose(
  withSnackBar,
  withState('isEditing', 'setEditing', false),
  withState('isEmptyLink', 'setEmptyLink', false),
  withState('isEmptyStatic', 'setEmptyStatic', false),
  withFetchResources({
    resourceName: 'pages',
    getAction: () => CmsApis.getPages,
  }),
  withDynamicEditPage({
    resourceByKeys: {
      staticPages: {
        initialState: [],
        fetchResource: CmsApis.getStaticPages,
        updateResource: CmsApis.updateStaticPages,
      },
      linkPages: {
        initialState: [],
        fetchResource: CmsApis.getLinkPages,
        updateResource: CmsApis.updateLinkPages,
      }
    },
    getFetchRequestMessage: () => 'Gathering page locations...',
  })
)(
  ({
    staticPages,
    setStaticPages,
    pages,
    fetchPagesStatus,
    isStateChanged,
    setIsStateChanged,
    resetState,
    linkPages,
    setLinkPages,
    onUpdateAllResources,
    updateAllResourcesStatus,
    setEditing,
    isEditing,
    isEmptyLink,
    setEmptyLink,
    isEmptyStatic,
    setEmptyStatic,
  }) => {
    const handleStaticPageChange = (val, key) => {
      setIsStateChanged(true);
      return setStaticPages(updateObject(staticPages, { [key]: val }));
    };

    const handleLinkPagesChange = (val, index) => {
      setIsStateChanged(true)
      return setLinkPages(updateItemArrayByIndex(linkPages, index, () => val))
    }
    
    const handleRemoveLinkPage = (index) => {
      setIsStateChanged(true);
      const result = removeItemArrayByIndex(linkPages, index)
      return setLinkPages(result)
    }
 
    const isLinkFieldEmpty = () => {
      if (!isEmpty(linkPages)) {
        return linkPages.some((linkPage) => (
          !linkPage.link || isEmpty(linkPage.pageSchedule) || linkPage.pageSchedule.some((schedule) => !schedule.pageId || !schedule.start || !schedule.end)
        ))
      }
      return false
    }

    const isStaticFieldEmpty = () => {
      if (!isEmpty(staticPages)) {
        return keys(staticPages).some((key) => (
          isEmpty(staticPages[key].pageSchedule) || staticPages[key].pageSchedule.some((schedule) => !schedule.pageId || !schedule.start || !schedule.end)
        ))
      }
      return false
    }

    const sortStaticPages = () => {
      keys(staticPages).map((key, i) => {
        staticPages[key].pageSchedule.sort((a, b) => (
          a.start - b.start
        ))
      })
    }

    const sortLinkPages = () => {
      linkPages.map((linkPage) => {
        linkPage.pageSchedule.sort((a, b) => (
          a.start - b.start
        ))
      })
    }

    const hideError = () => {
      setEmptyLink(false)
      setEmptyStatic(false)
    }
    return (
      <PageContent>
        <Paper>
          <StateToolbar
            primary={isStateChanged}
            isStateChanged={isStateChanged}
            onDiscard={() => {
              setIsStateChanged(false);
              setEditing(false)
              resetState()
              hideError()
            }}
            onSave={() => {
              if (!isLinkFieldEmpty() && !isStaticFieldEmpty()) {
                sortStaticPages()
                sortLinkPages()
                onUpdateAllResources(() => {
                  setIsStateChanged(false)
                  setEditing(false)
                  hideError()
                })
              } else {
                if (isLinkFieldEmpty()) {
                  setEmptyLink(true)
                }
                if (isStaticFieldEmpty()) {
                  setEmptyStatic(true)
                }
              }
            }}
            saveStatus={updateAllResourcesStatus}
          >
            { !isStateChanged &&
              (isEditing ?
                <CustomFlatButton
                  backgroundColor="red"
                  white
                  label="Cancel"
                  onTouchTap={() => {
                    resetState()
                    setEditing(false)
                    hideError()
                  }}
                  icon={
                    <FontIcon
                      className="fa fa-times"
                      color="white"
                    />
                  }
                />
                :
                <CustomFlatButton
                  backgroundColor="black"
                  white
                  label="Edit"
                  onTouchTap={() => setEditing(true)}
                  icon={
                    <FontIcon
                      className="fa fa-pencil"
                      color="white"
                    />
                  }
                />
              )
            }
          </StateToolbar>
          <PageContent>
            <MainHeader>Fix Pages</MainHeader>
            { isEmptyStatic &&
              <Message negative>
                <p>Please fill empty inputs.</p>
              </Message>
            }
            {
              keys(staticPages).map((key, i) => (
                <div>
                  <FormStaticPage
                    staticPage={staticPages[key]}
                    key={i}
                    title={upperFirst(key)}
                    setEditing={setEditing}
                    isEditing={isEditing}
                    hideError={hideError}
                    pages={pages.map(({ id, name }) => ({ label: name, value: id }))}
                    onSubmit={(value) => handleStaticPageChange(value, key)}
                  />
                  <Divider />
                </div>
              ))
            }
            <MainHeader >Link Pages</MainHeader>
            { isEmptyLink &&
              <Message negative>
                <p>Please fill empty inputs.</p>
              </Message>
            }
            <div style={{ textAlign: 'right' }}>

              {linkPages && linkPages.length > 0 &&
                linkPages.map((item, i) => {
                  return (
                    <div>
                      <FormLinkPage
                        linkPage={item}
                        key={i}
                        setEditing={setEditing}
                        isEditing={isEditing}
                        hideError={hideError}
                        pages={pages.map(({ id, name }) => ({ label: name, value: id }))}
                        onSubmit={(value) => handleLinkPagesChange(value, i)}
                        onRemove={() => handleRemoveLinkPage(i)}
                      />
                      <Divider />
                    </div>
                  )
                })
              }
              <div style={styles.addButton}>
                <FloatingActionButton
                  mini
                  onTouchTap={() => {
                    setLinkPages([...linkPages, { pageSchedule: [{}] }])
                    setEditing(true)
                    hideError()
                  }}
                >
                  <ContentAdd />
                </FloatingActionButton>
              </div>
            </div>
          </PageContent>
        </Paper>
      </PageContent>
    );
  },
);

PageLocations.propTypes = {};
PageLocations.defaultProps = {};

export default PageLocations;



// WEBPACK FOOTER //
// ./src/pages/CustomPages/children/PageLocations.js